<ui-card
    [withSpacing]="false"
    [withMargin]="false"
    [class.loading]="notificationService.isLoading$ || taskViewer?.isLoading | async"
    class="flex col"
    id="inbox-viewer"
>
    <!--Tab Bar-->
    <div class="tab-bar margin-right-4 margin-left-4">
        <div class="tabs" role="tablist">
            <!--Notifications Tab-->
            <button
                class="tab-button padding-top-1 padding-bottom-1 padding-left-0 padding-right-0"
                id="notifications-tab"
                [class.active]="activeTab === 'notifications'"
                (click)="setActiveTab('notifications')"
                role="tab"
                aria-controls="inbox-panel"
                [attr.aria-selected]="activeTab === 'notifications'"
            >
                <span class="tab-label">{{ 'dashboard.inbox' | translate }}</span>
                <span class="margin-left-1 counter" *ngIf="totalNumberOfUnreadNotifications > 0">
                    {{ totalNumberOfUnreadNotifications > 99 ? '99+' : totalNumberOfUnreadNotifications }}
                </span>
            </button>

            <!--Tasks Tab-->
            <button
                id="tasks-tab"
                class="tab-button padding-top-1 padding-bottom-1"
                (click)="setActiveTab('tasks')"
                [class.active]="activeTab === 'tasks'"
                role="tab"
                aria-controls="inbox-panel"
                [attr.aria-selected]="activeTab === 'tasks'"
            >
                <span class="tab-label">{{ 'dashboard.myTasks' | translate }}</span>
                <span class="margin-left-1 counter" *ngIf="tasksService.totalIncompleteUserTasks > 0">
                    {{ tasksService.totalIncompleteUserTasks > 99 ? '99+' : tasksService.totalIncompleteUserTasks }}
                </span>
            </button>
        </div>
        <!--Show 'Company dropdown' incase of tasks-->
        <div class="allTasks">
            <ng-container *ngIf="activeTab === 'tasks' && isAdmin">
                <ui-button class="margin-right-1" size="no-padding" (click)="navigateToAllTasksView()" type="link">
                    {{ 'dashboard.allTasks' | translate }} <mat-icon svgIcon="chevronRight"></mat-icon
                ></ui-button>
            </ng-container>
        </div>
        <div class="right-section">
            @if (hasImprovedHomepageFlag && activeTab !== 'tasks') {
                <ui-button
                    id="notifications-filter"
                    size="min-padding"
                    [matMenuTriggerFor]="filter"
                    class="filter-icon"
                    aria-label="{{ 'settings.menu.notifications' | translate }} {{
                        'components.iconLabels.filter' | translate
                    }}"
                >
                    <mat-icon [svgIcon]="isFilterActive ? 'filterListActive' : 'filterList'"></mat-icon>
                </ui-button>

                <mat-menu #filter="matMenu" xPosition="after" aria-labelledby="notifications-filter">
                    <button mat-menu-item [matMenuTriggerFor]="date">
                        {{ 'dashboard.filterByDateRange' | translate }}
                    </button>
                    <button mat-menu-item [matMenuTriggerFor]="category">
                        {{ 'dashboard.filterByCategory' | translate }}
                    </button>
                </mat-menu>

                <mat-menu #date="matMenu" xPosition="after">
                    <button
                        (click)="onDateFilter(notificationDateFilter)"
                        *ngFor="let notificationDateFilter of notificationDateFilters"
                        mat-menu-item
                    >
                        {{ notificationDateFilter.displayName | translate }}
                    </button>
                </mat-menu>

                <mat-menu #category="matMenu" xPosition="after" class="category-list">
                    <button (click)="onCategoryFilter({ displayName: 'all', id: -1 })" mat-menu-item>
                        {{ 'dashboard.allCategories' | translate }}
                    </button>
                    <button
                        (click)="
                            onCategoryFilter({
                                displayName: notificationCategory.displayName,
                                id: notificationCategory.id,
                            })
                        "
                        mat-menu-item
                        *ngFor="let notificationCategory of notificationCategories"
                    >
                        {{ notificationCategory.displayName | translate }}
                    </button>
                </mat-menu>
            }

            <!-- Tab Menu-->
            <ui-button
                [matMenu]="meatball"
                class="meatball tab-menu"
                [class.notifications-tab-menu]="activeTab === 'notifications'"
                size="min-padding"
                [class.tasks-trigger]="activeTab === 'tasks' && isAdmin"
            >
                <mat-icon svgIcon="meatballHorizontal"></mat-icon>
            </ui-button>
            <mat-menu #meatball xPosition="before">
                <ng-container *ngIf="activeTab === 'notifications'">
                    <button (click)="onMarkAllAsRead()" mat-menu-item>
                        {{ 'dashboard.markAllAsRead' | translate }}
                    </button>

                    <button (click)="onArchiveAll()" mat-menu-item>{{ 'dashboard.archiveAll' | translate }}</button>

                    <button (click)="goToArchivePage()" mat-menu-item>
                        {{ 'dashboard.viewArchived' | translate }}
                        <span *ngIf="totalNumberOfUnreadArchivedNotifications > 0" class="margin-left-1 counter">
                            {{
                                totalNumberOfUnreadArchivedNotifications > 99
                                    ? '99+'
                                    : totalNumberOfUnreadArchivedNotifications
                            }}
                        </span>
                    </button>
                </ng-container>

                <ng-container *ngIf="activeTab === 'tasks'">
                    <button (click)="goToCompletedTasksPage()" mat-menu-item>
                        {{ 'dashboard.viewCompletedTasks' | translate }}
                    </button>
                </ng-container>
            </mat-menu>
        </div>
    </div>

    @if (activeTab === 'notifications') {
        <ng-container *ngIf="hasImprovedHomepageFlag">
            <div class="margin-top-2 margin-left-4 margin-bottom-2 margin-right-4">
                <div class="grid-row" aria-label="notification-type-tabs">
                    <app-chip-filters
                        aria-label="{{ 'dashboard.inbox' | translate }} {{ 'filters' | translate }}"
                        class="filters"
                        [chips]="chips"
                        (chipSelected)="notificationService.filterByStatus($event)"
                    ></app-chip-filters>

                    <app-pagination
                        [total]="notificationService.totalNumberOfNotifications"
                        [current]="notificationService.currentPage"
                        (pageChange)="notificationService.onPageChange(false, $event)"
                        class="pagination"
                    ></app-pagination>
                </div>
            </div>

            <div
                *ngIf="(notificationService.isLoading$ | async) === false"
                class="chip-list margin-left-4 margin-bottom-1"
            >
                <mat-chip-set
                    role="list"
                    attr.aria-label="{{ 'dashboard.screen-reader-only.notificationFilterList' | translate }}"
                >
                    <mat-chip
                        *ngFor="let chip of chipsToDisplay; let i = index"
                        aria-label="{{ chip.displayName | translate }}"
                        role="listitem"
                    >
                        {{ chip.displayName | translate }}
                        <div
                            matChipRemove
                            role="button"
                            class="flex"
                            (click)="removeFilter(chip)"
                            attr.aria-label="{{ 'remove' | translate }} {{ chip.displayName | translate }} {{
                                'filter' | translate
                            }}"
                        >
                            <mat-icon svgIcon="close" />
                        </div>
                    </mat-chip>
                    <mat-chip-option
                        *ngIf="chipsToDisplay.length"
                        (click)="removeFilter({ displayName: 'dashboard.clearFilters', value: 'clear' })"
                    >
                        {{ 'dashboard.clearFilters' | translate }}
                    </mat-chip-option>
                </mat-chip-set>
            </div>
        </ng-container>

        <!--Notifications-->
        <app-notification-viewer
            role="tabpanel"
            id="inbox-panel"
            aria-labelledby="notifications-tab"
            (notificationsUpdated)="getUnreadNotificationsCount(); getUnreadArchivedNotificationsCount()"
            (readStateUpdated)="getUnreadNotificationsCount()"
            #notificationViewer
        ></app-notification-viewer>
    }
    <!--Tasks-->
    <app-task-viewer
        [class.hasAllTasks]="activeTab === 'tasks' && isAdmin"
        role="tabpanel"
        id="inbox-panel"
        aria-labelledby="tasks-tab"
        #taskViewer
        *ngIf="activeTab === 'tasks'"
        [style.display]="activeTab === 'tasks' ? 'block' : 'none'"
        [showTaskId]="showTaskId"
    ></app-task-viewer>
</ui-card>
